import { UniformSlot } from "@uniformdev/canvas-react";
import { ManifestErrorMessage } from "src/uniform/utils/manifest-error-message";
import { useWAEContextSafe } from "src/uniform/utils/wae-context-provider";

import { checkFeatureFlagGate } from "@/utils/feature-flags";
import { featureFlags, FeatureFlag } from "@/utils/feature-flags";

export interface UniformFeatureGateProps {
    featureGateId: string;
    override?: "control" | "treatment";
}

const UniformFeatureGate = (props: UniformFeatureGateProps) => {
    const { featureGateId, override } = props;

    const context = useWAEContextSafe();

    const featureGate = Object.entries(featureFlags).find(
        ([, value]) => value.featureFlagName === featureGateId
    )?.[1];

    if (override && context?.wacEnvironment !== "production") {
        return <UniformSlot name={override} />;
    }

    if (!featureGate) {
        return context?.wacEnvironment === "production" ? null : (
            <>
                <ManifestErrorMessage id={featureGateId} />
                <UniformSlot name="control" />
            </>
        );
    }

    const showTreatment = checkFeatureFlagGate(featureGate as FeatureFlag);

    return <UniformSlot name={showTreatment ? "treatment" : "control"} />;
};

export default UniformFeatureGate;
